<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Reporte de Marketing</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_exportarExcel()">
          <span v-bind:style="{ color: 'white' }">
            Exportar a Excel
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaDesde" autocomplete="off"
              label="Búsqueda por fecha desde" placeholder="AAAA-MM-DD"
              @keyup.enter="_getReporteMarketing()" 
              :error-messages="errorDesde"
              @input="validateFechaDesde"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaHasta" autocomplete="off"
              label="Búsqueda por fecha hasta" placeholder="AAAA-MM-DD" 
              @keyup.enter="_getReporteMarketing()"
              :error-messages="errorHasta"
              @input="validateFechaHasta"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-if="!loading" class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Estadísticas por Caminos</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
       
      </v-toolbar>
      <v-card-text>
         <v-row v-if="reporteMarketing && reporteMarketing.por_camino" class="mt-2" justify="center" dense>
           <v-col cols="12">
             <v-card class="pa-4">
               <h2 class="mb-4 text-center">Distribución de Reservas por Camino</h2>
               <v-row>
                 <v-col cols="12" md="6" class="d-flex justify-center align-center">
                   <canvas ref="pieChart" width="400" height="400"></canvas>
                 </v-col>
                 <v-col cols="12" md="6" class="d-flex align-center">
                   <div ref="leyendaContainer" style="width: 100%;"></div>
                 </v-col>
               </v-row>
             </v-card>
           </v-col>
         </v-row>
        <v-row v-if="reporteMarketing && reporteMarketing.por_camino" class="mt-2" justify="start" dense>
          <v-col cols="12" >
            
            <v-data-table v-if="reporteMarketing && reporteMarketing.por_camino" locale="es" dense :headers="headersPorCamino" hide-default-footer :items="reporteMarketing.por_camino"
              :items-per-page="-1"
              class="mt-2 elevation-1 alternating-rows bordered-table">
              <template v-slot:no-data>
                No hay datos disponibles
              </template>
              <template v-slot:body.append>
                <tr class="font-weight-bold" style="background-color: #e3f2fd;">
                  <td colspan="2" class="text-left">TOTALES</td>
                  <td class="text-center">{{ totalesPorCamino.DesdeWebPresupuestadas }}</td>
                  <td class="text-center">{{ totalesPorCamino.DesdeWebReservadas }}</td>
                  <td class="text-center">{{ totalesPorCamino.DesdeOficinaPresupuestadas }}</td>
                  <td class="text-center">{{ totalesPorCamino.DesdeOficinaReservadas }}</td>
                  <td class="text-center">{{ totalesPorCamino.total }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        

        
      </v-card-text>
    </v-card>

    <v-card v-if="!loading" class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Estadísticas por Categoría</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
       
      </v-toolbar>
      <v-card-text>
        <!-- Gráfica de Pastel por Categoría -->
        <v-row v-if="reporteMarketing && reporteMarketing.por_categoria" class="mt-2" justify="center" dense>
          <v-col cols="12">
            <v-card class="pa-4">
              <h2 class="mb-4 text-center">Distribución de Reservas por Categoría</h2>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center align-center">
                  <canvas ref="pieChartCategoria" width="400" height="400"></canvas>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div ref="leyendaContainerCategoria" style="width: 100%;"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
         
        <v-row v-if="reporteMarketing && reporteMarketing.por_categoria" class="mt-2" justify="start" dense>
          <v-col cols="12" >
            <v-data-table v-if="reporteMarketing && reporteMarketing.por_categoria" locale="es" dense :headers="headersPorCategoria" hide-default-footer :items="reporteMarketing.por_categoria"
              :items-per-page="-1"
              class="mt-2 elevation-1 alternating-rows bordered-table">
              <template v-slot:no-data>
                No hay datos disponibles
              </template>
              <template v-slot:body.append>
                <tr class="font-weight-bold" style="background-color: #e3f2fd;">
                  <td class="text-left">TOTALES</td>
                  <td class="text-center">{{ totalesPorCategoria.DesdeWebPresupuestadas }}</td>
                  <td class="text-center">{{ totalesPorCategoria.DesdeWebReservadas }}</td>
                  <td class="text-center">{{ totalesPorCategoria.DesdeOficinaPresupuestadas }}</td>
                  <td class="text-center">{{ totalesPorCategoria.DesdeOficinaReservadas }}</td>
                  <td class="text-center">{{ totalesPorCategoria.total }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as XLSX from 'xlsx';

export default {
  data: () => ({
    mostrarbusqueda: true,
    busquedaDesde: "",
    busquedaHasta: "",
    errorDesde: "",
    errorHasta: "",
    

    headersPorCamino: [
      
      {
        text: "CAMINO",
        align: "left",
        sortable: false,
        value: "camino_nombre",
      },
      {
        text: "CATEGORIA",
        align: "left",
        sortable: false,
        value: "categoria_nombre",
        width: "200px"
      },
      {
        text: "DESDE WEB PRESUPUESTADAS",
        align: "center",
        sortable: false,
        value: "DesdeWebPresupuestadas",
        width: "130px"
      },
      {
        text: "DESDE WEB CONFIRMADAS",
        align: "center",
        sortable: false,
        value: "DesdeWebReservadas",
        width: "130px"
      },
      {
        text: "DESDE OFICINA PRESUPUESTADAS",
        align: "center",
        sortable: false,
        value: "DesdeOficinaPresupuestadas",
        width: "130px"
      },
      {
        text: "DESDE OFICINA CONFIRMADAS",
        align: "center",
        sortable: false,
        value: "DesdeOficinaReservadas",
        width: "130px"
      },
      {
        text: "TOTAL",
        align: "center",
        sortable: false,
        value: "total_reservas",
        width: "130px"
      },
    ],

    headersPorCategoria: [
      {
        text: "CATEGORIA",
        align: "left",
        sortable: false,
        value: "categoria_nombre",
      },
      {
        text: "DESDE WEB PRESUPUESTADAS",
        align: "center",
        sortable: false,
        value: "DesdeWebPresupuestadas",
        width: "130px"
      },
      {
        text: "DESDE WEB CONFIRMADAS",
        align: "center",
        sortable: false,
        value: "DesdeWebReservadas",
        width: "130px"
      },
      {
        text: "DESDE OFICINA PRESUPUESTADAS",
        align: "center",
        sortable: false,
        value: "DesdeOficinaPresupuestadas",
        width: "130px"
      },
      {
        text: "DESDE OFICINA CONFIRMADAS",
        align: "center",
        sortable: false,
        value: "DesdeOficinaReservadas",
        width: "130px"
      },
      {
        text: "TOTAL",
        align: "center",
        sortable: false,
        value: "total_reservas",
        width: "130px"
      },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("reportes", ["reporteMarketing"]),

    totalesPorCamino() {
      if (!this.reporteMarketing || !this.reporteMarketing.por_camino) {
        return {
          DesdeWebPresupuestadas: 0,
          DesdeWebReservadas: 0,
          DesdeOficinaPresupuestadas: 0,
          DesdeOficinaReservadas: 0,
          total: 0
        };
      }
      
      return this.reporteMarketing.por_camino.reduce((acc, item) => {
        acc.DesdeWebPresupuestadas += parseInt(item.DesdeWebPresupuestadas) || 0;
        acc.DesdeWebReservadas += parseInt(item.DesdeWebReservadas) || 0;
        acc.DesdeOficinaPresupuestadas += parseInt(item.DesdeOficinaPresupuestadas) || 0;
        acc.DesdeOficinaReservadas += parseInt(item.DesdeOficinaReservadas) || 0;
        acc.total += parseInt(item.total_reservas) || 0;
        return acc;
      }, {
        DesdeWebPresupuestadas: 0,
        DesdeWebReservadas: 0,
        DesdeOficinaPresupuestadas: 0,
        DesdeOficinaReservadas: 0,
        total: 0
      });
    },

    totalesPorCategoria() {
      if (!this.reporteMarketing || !this.reporteMarketing.por_categoria) {
        return {
          DesdeWebPresupuestadas: 0,
          DesdeWebReservadas: 0,
          DesdeOficinaPresupuestadas: 0,
          DesdeOficinaReservadas: 0,
          total: 0
        };
      }
      
      return this.reporteMarketing.por_categoria.reduce((acc, item) => {
        acc.DesdeWebPresupuestadas += parseInt(item.DesdeWebPresupuestadas) || 0;
        acc.DesdeWebReservadas += parseInt(item.DesdeWebReservadas) || 0;
        acc.DesdeOficinaPresupuestadas += parseInt(item.DesdeOficinaPresupuestadas) || 0;
        acc.DesdeOficinaReservadas += parseInt(item.DesdeOficinaReservadas) || 0;
        acc.total += parseInt(item.total_reservas) || 0;
        return acc;
      }, {
        DesdeWebPresupuestadas: 0,
        DesdeWebReservadas: 0,
        DesdeOficinaPresupuestadas: 0,
        DesdeOficinaReservadas: 0,
        total: 0
      });
    },
  },

  watch: {
    'reporteMarketing.por_camino': {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastel();
        });
      },
      deep: true
    },
    'reporteMarketing.por_categoria': {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastelCategoria();
        });
      },
      deep: true
    }
  },
  
  mounted() {
    this._getReporteMarketing();
  },

  methods: {
    ...mapActions("reportes", ["getReporteMarketing"]),

    dibujarGraficaPastel() {
      if (!this.reporteMarketing || !this.reporteMarketing.por_camino || !this.$refs.pieChart) {
        return;
      }

      const canvas = this.$refs.pieChart;
      const ctx = canvas.getContext('2d');
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 40;

      // Preparar datos
      const datos = this.reporteMarketing.por_camino.map(item => ({
        label: item.camino_nombre,
        value: parseInt(item.total_reservas) || 0,
        categoria: item.categoria_nombre
      }));

      // Filtrar los que tienen valor 0
      const datosConValor = datos.filter(d => d.value > 0);

      if (datosConValor.length === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '16px Arial';
        ctx.fillStyle = '#666';
        ctx.textAlign = 'center';
        ctx.fillText('No hay datos para mostrar', centerX, centerY);
        if (this.$refs.leyendaContainer) {
          this.$refs.leyendaContainer.innerHTML = '';
        }
        return;
      }

      const total = datosConValor.reduce((sum, d) => sum + d.value, 0);

      // Colores vibrantes para la gráfica
      const colores = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
        '#FF9F40', '#FF6384', '#C9CBCF', '#4BC0C0', '#FF9F40',
        '#FFCD56', '#36A2EB', '#9966FF', '#FF6384', '#4BC0C0'
      ];

      // Limpiar canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Dibujar sectores
      let startAngle = -Math.PI / 2; // Empezar desde arriba

      datosConValor.forEach((dato, index) => {
        const sliceAngle = (dato.value / total) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;

        // Dibujar sector
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = colores[index % colores.length];
        ctx.fill();
        
        // Borde blanco
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();

        // Calcular posición para el porcentaje (en el centro del sector)
        const percentage = ((dato.value / total) * 100).toFixed(1);
        if (percentage > 5) { // Solo mostrar si es mayor al 5%
          const midAngle = startAngle + sliceAngle / 2;
          const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
          const textY = centerY + (radius * 0.7) * Math.sin(midAngle);
          
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(`${percentage}%`, textX, textY);
        }

        startAngle = endAngle;
      });

      // Crear leyenda en HTML (al lado del gráfico)
      if (this.$refs.leyendaContainer) {
        let leyendaHTML = '<div style="display: flex; flex-direction: column; gap: 12px; padding: 10px; max-height: 400px; overflow-y: auto;">';
        
        datosConValor.forEach((dato, index) => {
          const percentage = ((dato.value / total) * 100).toFixed(1);
          const color = colores[index % colores.length];
          
          leyendaHTML += `
            <div style="display: flex; align-items: center; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
              <div style="width: 24px; height: 24px; background-color: ${color}; border: 2px solid #333; margin-right: 12px; flex-shrink: 0; border-radius: 3px;"></div>
              <span style="font-size: 14px; color: #333; line-height: 1.4;">
                <strong>${dato.label}</strong><br>
                <span style="color: #666;">${dato.value} reservas (${percentage}%)</span>
              </span>
            </div>
          `;
        });
        
        leyendaHTML += '</div>';
        this.$refs.leyendaContainer.innerHTML = leyendaHTML;
      }
    },

    dibujarGraficaPastelCategoria() {
      if (!this.reporteMarketing || !this.reporteMarketing.por_categoria || !this.$refs.pieChartCategoria) {
        return;
      }

      const canvas = this.$refs.pieChartCategoria;
      const ctx = canvas.getContext('2d');
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 40;

      // Preparar datos
      const datos = this.reporteMarketing.por_categoria.map(item => ({
        label: item.categoria_nombre,
        value: parseInt(item.total_reservas) || 0
      }));

      // Filtrar los que tienen valor 0
      const datosConValor = datos.filter(d => d.value > 0);

      if (datosConValor.length === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '16px Arial';
        ctx.fillStyle = '#666';
        ctx.textAlign = 'center';
        ctx.fillText('No hay datos para mostrar', centerX, centerY);
        if (this.$refs.leyendaContainerCategoria) {
          this.$refs.leyendaContainerCategoria.innerHTML = '';
        }
        return;
      }

      const total = datosConValor.reduce((sum, d) => sum + d.value, 0);

      // Colores vibrantes para la gráfica
      const colores = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
        '#FF9F40', '#FF6384', '#C9CBCF', '#4BC0C0', '#FF9F40',
        '#FFCD56', '#36A2EB', '#9966FF', '#FF6384', '#4BC0C0'
      ];

      // Limpiar canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Dibujar sectores
      let startAngle = -Math.PI / 2; // Empezar desde arriba

      datosConValor.forEach((dato, index) => {
        const sliceAngle = (dato.value / total) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;

        // Dibujar sector
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = colores[index % colores.length];
        ctx.fill();
        
        // Borde blanco
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();

        // Calcular posición para el porcentaje (en el centro del sector)
        const percentage = ((dato.value / total) * 100).toFixed(1);
        if (percentage > 5) { // Solo mostrar si es mayor al 5%
          const midAngle = startAngle + sliceAngle / 2;
          const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
          const textY = centerY + (radius * 0.7) * Math.sin(midAngle);
          
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(`${percentage}%`, textX, textY);
        }

        startAngle = endAngle;
      });

      // Crear leyenda en HTML (al lado del gráfico)
      if (this.$refs.leyendaContainerCategoria) {
        let leyendaHTML = '<div style="display: flex; flex-direction: column; gap: 12px; padding: 10px; max-height: 400px; overflow-y: auto;">';
        
        datosConValor.forEach((dato, index) => {
          const percentage = ((dato.value / total) * 100).toFixed(1);
          const color = colores[index % colores.length];
          
          leyendaHTML += `
            <div style="display: flex; align-items: center; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
              <div style="width: 24px; height: 24px; background-color: ${color}; border: 2px solid #333; margin-right: 12px; flex-shrink: 0; border-radius: 3px;"></div>
              <span style="font-size: 14px; color: #333; line-height: 1.4;">
                <strong>${dato.label}</strong><br>
                <span style="color: #666;">${dato.value} reservas (${percentage}%)</span>
              </span>
            </div>
          `;
        });
        
        leyendaHTML += '</div>';
        this.$refs.leyendaContainerCategoria.innerHTML = leyendaHTML;
      }
    },
   
    rowClass(item, index) {
      return index % 2 === 0 ? 'light-blue-row' : '';
    },

    _exportarExcel() {
      if (!this.reporteMarketing || !this.reporteMarketing.por_camino) {
        return;
      }

      // Crear el libro de trabajo
      const wb = XLSX.utils.book_new();

      // ===== SHEET 1: Reporte por Camino =====
      const datosPorCamino = this.reporteMarketing.por_camino.map(item => ({
        'CATEGORIA': item.categoria_nombre || '',
        'CAMINO': item.camino_nombre || '',
        'DESDE WEB PRESUPUESTADAS': item.DesdeWebPresupuestadas || 0,
        'DESDE WEB CONFIRMADAS': item.DesdeWebReservadas || 0,
        'DESDE OFICINA PRESUPUESTADAS': item.DesdeOficinaPresupuestadas || 0,
        'DESDE OFICINA CONFIRMADAS': item.DesdeOficinaReservadas || 0,
        'TOTAL': item.total_reservas || 0
      }));

      // Agregar fila de totales
      datosPorCamino.push({
        'CATEGORIA': '',
        'CAMINO': 'TOTALES',
        'DESDE WEB PRESUPUESTADAS': this.totalesPorCamino.DesdeWebPresupuestadas,
        'DESDE WEB CONFIRMADAS': this.totalesPorCamino.DesdeWebReservadas,
        'DESDE OFICINA PRESUPUESTADAS': this.totalesPorCamino.DesdeOficinaPresupuestadas,
        'DESDE OFICINA CONFIRMADAS': this.totalesPorCamino.DesdeOficinaReservadas,
        'TOTAL': this.totalesPorCamino.total
      });

      const wsPorCamino = XLSX.utils.json_to_sheet(datosPorCamino);
      XLSX.utils.book_append_sheet(wb, wsPorCamino, "Por Camino");

      // ===== SHEET 2: Reporte por Categoría =====
      if (this.reporteMarketing.por_categoria) {
        const datosPorCategoria = this.reporteMarketing.por_categoria.map(item => ({
          'CATEGORIA': item.categoria_nombre || '',
          'DESDE WEB PRESUPUESTADAS': item.DesdeWebPresupuestadas || 0,
          'DESDE WEB CONFIRMADAS': item.DesdeWebReservadas || 0,
          'DESDE OFICINA PRESUPUESTADAS': item.DesdeOficinaPresupuestadas || 0,
          'DESDE OFICINA CONFIRMADAS': item.DesdeOficinaReservadas || 0,
          'TOTAL': item.total_reservas || 0
        }));

        // Agregar fila de totales
        datosPorCategoria.push({
          'CATEGORIA': 'TOTALES',
          'DESDE WEB PRESUPUESTADAS': this.totalesPorCategoria.DesdeWebPresupuestadas,
          'DESDE WEB CONFIRMADAS': this.totalesPorCategoria.DesdeWebReservadas,
          'DESDE OFICINA PRESUPUESTADAS': this.totalesPorCategoria.DesdeOficinaPresupuestadas,
          'DESDE OFICINA CONFIRMADAS': this.totalesPorCategoria.DesdeOficinaReservadas,
          'TOTAL': this.totalesPorCategoria.total
        });

        const wsPorCategoria = XLSX.utils.json_to_sheet(datosPorCategoria);
        XLSX.utils.book_append_sheet(wb, wsPorCategoria, "Por Categoría");
      }

      // Generar nombre del archivo con la fecha actual
      const fecha = new Date().toISOString().split('T')[0];
      const nombreArchivo = `Reporte_Marketing_${fecha}.xlsx`;

      // Descargar el archivo
      XLSX.writeFile(wb, nombreArchivo);
      
    },

    validateFechaDesde() {
      this.errorDesde = "";
      if (this.busquedaDesde && !this.isValidDateFormat(this.busquedaDesde)) {
        this.errorDesde = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    validateFechaHasta() {
      this.errorHasta = "";
      if (this.busquedaHasta && !this.isValidDateFormat(this.busquedaHasta)) {
        this.errorHasta = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    isValidDateFormat(dateString) {
      // Expresión regular para validar formato YYYY-MM-DD
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      
      if (!dateRegex.test(dateString)) {
        return false;
      }

      // Validar que sea una fecha válida
      const date = new Date(dateString);
      const [year, month, day] = dateString.split('-').map(Number);
      
      return date.getFullYear() === year && 
             date.getMonth() === month - 1 && 
             date.getDate() === day;
    },

    async _getReporteMarketing() {
      // Validar fechas antes de buscar
      this.validateFechaDesde();
      this.validateFechaHasta();

      // Si hay errores, no continuar con la búsqueda
      if (this.errorDesde || this.errorHasta) {
        return;
      }

      const params = {};
      if (this.busquedaDesde != null && this.busquedaDesde != "") {
        params.fecha_desde = this.busquedaDesde;
      }
      if (this.busquedaHasta != null && this.busquedaHasta != "") {
        params.fecha_hasta = this.busquedaHasta;
      }
      await this.getReporteMarketing([this.access_token, params]);
    },
    
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}


.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
